import {Empresa} from './empresa.model';
import {DetailField} from '../../../shared';

export interface EmpresasDetailParams {
  empresa: Empresa;
  fields?: DetailField[];
}
